'use client';

import { ConfiguratorForm } from '@eliadmin/core/src/components/configurator/configurator-form';
import { ConfiguratorMobileMenu } from '@eliadmin/core/src/components/configurator/configurator-mobile-menu';
import { ConfiguratorNavigation } from '@eliadmin/core/src/components/configurator/configurator-navigation';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { Suspense } from 'react';

export default function ConfiguratorPage() {
  const isCustomerInitialized = useCustomerStore(s => s.isInitialized);

  if (!isCustomerInitialized) return <GenericLoader />;

  return (
    <div className="z-100 fixed inset-0 h-screen w-screen overflow-y-scroll bg-background">
      <ConfiguratorNavigation />
      <div className="mt-8 w-full px-0 pb-44 md:px-4 md:pb-12">
        <Suspense>
          <ConfiguratorForm />
        </Suspense>
      </div>
      <ConfiguratorMobileMenu />
    </div>
  );
}
